import i18next from "i18next";
import { getSupportedLng } from "./i18nextOptions";

/**
 * Return the current locale in lowercase (For example: 'en-us')
 */
export const currentLocale = () => getSupportedLng({ language: i18next.language }).toLocaleLowerCase();
